<div class="upload-header">
	<flx-heading *ngIf="heading !== null" size="medium" align="center">{{ heading }}</flx-heading>
	<flx-heading *ngIf="subheading !== null" size="small" align="center">{{ subheading }}</flx-heading>
</div>
<div id="my-dynamic-table"><flx-heading size="small" type="page" align="center">Nothing to display</flx-heading></div>
